import script from "./RecentAncestryUploadStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentAncestryUploadStatus.vue?vue&type=script&setup=true&lang=js"

import "./RecentAncestryUploadStatus.vue?vue&type=style&index=0&id=d46b2100&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d46b2100"]])

export default __exports__